// SPDX-License-Identifier: Apache-2.0

// add new version of fabric here
const FabricVersion = ['v2.3', 'v1.4'];

export default FabricVersion;
